import {initElements} from "../../define/shared";
import Splide from "@splidejs/splide";
import "@splidejs/splide/css";

export default function initSplitImages() {
    initElements(".split-images", block => {
        const thumbnailsEl = block.querySelector("#split-thumbnails");
        const imagesEl = block.querySelector("#split-images");

        if (!(thumbnailsEl && imagesEl)) {
            return;
        }
        document.addEventListener("DOMContentLoaded", function () {
            const sliderThumbnails = new Splide(thumbnailsEl, {
                fixedWidth: 150,
                fixedHeight: 150,
                rewind: true,
                pagination: false,
                perMove: 5,
                breakpoints: {
                    600: {
                        fixedWidth: 100,
                        fixedHeight: 100,
                        perMove: 3,
                    },
                    360: {
                        fixedWidth: 70,
                        fixedHeight: 70,
                    },
                },
            }).mount();

            const sliderImages = new Splide(imagesEl, {
                rewind: true,
                pagination: false,
                perMove: 1,
            }).mount();

            sliderImages.sync(sliderThumbnails)

            sliderThumbnails.on("click", (slide, e) => {
                sliderImages.go(slide.index);

            });
        });
    });
}
